import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { storeToRefs } from 'pinia'
import { hydrateOnIdle, hydrateOnVisible, watch } from 'vue'

import Footer from '@/components_new/Footer/Footer.vue'
import DesktopHeader from '@/components_new/Headers/DesktopHeader.vue'
import MobileHeader from '@/components_new/Headers/MobileHeader.vue'
import LazyHydration from '@/components_new/LazyHydration.vue'
import LeftSide from '@/components_new/LeftSide/LeftSide.vue'
import ModalCategories from '@/components_new/ModalCategories/ModalCategories.vue'
import ModalInvite from '@/components_new/ModalItems/components/ModalInvite.vue'
import ModalSurvey from '@/components_new/ModalItems/components/ModalSurvey/ModalSurvey.vue'
import { AvailableLocale } from '@/i18n/helpers'
import { useLayoutStore } from '@/store/layout-store'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModernLayout',
  props: {
    footerData: {}
  },
  setup(__props: any) {



const { fullScreen } = storeToRefs(useLayoutStore())

watch(fullScreen, (value) => {
    document.documentElement.classList.toggle('fullscreen_css', value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.grid)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.left)
      }, [
        _createVNode(LeftSide, {
          languageLinks: _ctx.footerData?.languageLinks
        }, null, 8, ["languageLinks"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.rightArea)
      }, [
        _createVNode(LazyHydration, {
          hydrate: hydrateOnVisible()
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.desktop_header)
            }, [
              _createVNode(DesktopHeader)
            ], 2)
          ]),
          _: 1
        }, 8, ["hydrate"]),
        _createVNode(LazyHydration, {
          hydrate: hydrateOnVisible()
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.mobile_header)
            }, [
              _createVNode(MobileHeader)
            ], 2)
          ]),
          _: 1
        }, 8, ["hydrate"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.main)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2),
        _createVNode(LazyHydration, {
          hydrate: hydrateOnVisible()
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.footer)
            }, [
              _createVNode(Footer, {
                languageLinks: _ctx.footerData?.languageLinks
              }, null, 8, ["languageLinks"])
            ], 2)
          ]),
          _: 1
        }, 8, ["hydrate"]),
        (_ctx.$slots['right-column'])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.right)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.right_wrapper)
              }, [
                _renderSlot(_ctx.$slots, "right-column")
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      _renderSlot(_ctx.$slots, "ad")
    ], 2),
    _createVNode(LazyHydration, {
      hydrate: hydrateOnIdle()
    }, {
      default: _withCtx(() => [
        _createVNode(ModalCategories),
        _createVNode(ModalInvite),
        _createVNode(ModalSurvey)
      ]),
      _: 1
    }, 8, ["hydrate"])
  ], 2))
}
}

})